import React, { useEffect, useState } from 'react';

import './MessageBox.scss';
interface IMessageBoxProps {
    type?: 'alert' | 'confirmation',
    isOpen: boolean,
    setIsOpen: (isOpen: boolean) => void,
    title: string,
    message: string,
    reference?: any,
    onConfirmClicked?: (reference: any) => void
}

const MessageBox = ({isOpen, setIsOpen, title, message, type, reference, onConfirmClicked}: IMessageBoxProps) => {

    if (!type)
        type = 'alert';

    const [open, setOpen] = useState(true);




    return (
    <div className={'message-box-container' + (isOpen ? ' shown' : '')}>
        <div className={"box"  + (isOpen ? ' shown' : '')}>
            <h4>{title}</h4>
            <div style={{maxHeight: '80vh', overflow: 'auto',}}>
                {!message.includes(`{`) && <p>{message}</p>}
                {message.includes(`{`) && <div style={{maxWidth: '100%', overflow: 'auto',}}><pre>{message}</pre></div>}
            </div>

            {type == 'alert' && <div className='d-flex justify-content-center'>
                <button className='btn' onClick={(evt) => setIsOpen(false)}>OK</button>
            </div>}

            {type == 'confirmation' && <div className='d-flex justify-content-between'>
                <button className='btn mr-5' onClick={(evt) => {setIsOpen(false)}}>CANCEL</button>
                <button className='btn btn-blue' onClick={(evt) => {setIsOpen(false); if (onConfirmClicked) onConfirmClicked(reference)}}>CONFIRM</button>
            </div>}
        </div>
    </div>)
}

export default MessageBox;